import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralService } from '../../core/services/general.service';
import { NotificacionesService } from '../../core/notificaciones/notificaciones.service';

@Component({
    templateUrl: './contact-dialog.component.html',
    styleUrls: ['./contact-dialog.component.scss']
})
export class ContactDialogComponent implements OnInit {

    form: FormGroup;

    constructor(
        private generalService: GeneralService,
        private notificaciones: NotificacionesService,
        private formBuilder: FormBuilder,
        private dialogRef: MatDialogRef<ContactDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) { }

    ngOnInit() {
        this.form = this.formBuilder.group({
            problema: [this.data.problema, Validators.required],
            descripcion: [this.data.descripcion, Validators.required]
        });

    }

    submit(form) {
        this.dialogRef.close();
        const formulario = {
            problem: form.value.problema,
            description: form.value.descripcion
        };
        this.generalService.sendContactForm(formulario).subscribe(
            data => {
                // console.log(data);
                this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Perfil.FormularioEnviado);
            },
            err => {
                console.error(err);
                this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Perfil.FormularioNoEnviado);
            }
        );
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/contact-dialog/contact-dialog.component.ts